import React, { Component } from 'react';
import { Link } from "react-router-dom";
import Cookies from 'js-cookie'
import Backbtn from './elements/Backbtn'
import { Footer, Nav, Analytics } from './elements'

class Partstype extends Component {

    constructor(){
        super()
        this.state = {
            title: "",
            type_wall: "",
            type_hang: "",
            type_four: "",
            type_concealed: "",
            type_stand: "",
            isLogin: false,
            user: ""
        }
    }

    componentWillMount() {
        if(Cookies.get('user')){
            this.setState({
                isLogin: true,
                user: JSON.parse(Cookies.get('user'))
            })
        } else {
            window.location = "/login"
        }
        let params = this.getParams()
        this.setState({ 
            title: params.title,
            type_wall: params.type_wall,
            type_hang: params.type_hang,
            type_four: params.type_four,
            type_concealed: params.type_concealed,
            type_stand: params.type_stand
        })
    }

    getParams() {
        const searchParams = new URLSearchParams(this.props.location.search);
        return {
            title: searchParams.get('title') || '',
            type_wall: searchParams.get('type_wall') || '',
            type_hang: searchParams.get('type_hang') || '',
            type_four: searchParams.get('type_four') || '',
            type_concealed: searchParams.get('type_concealed') || '',
            type_stand: searchParams.get('type_stand') || ''
        };
    }

    render() { 
        if(!this.state.isLogin) return <div></div>
        return ( 
            <div className="page-partstype">
                <Analytics />
                <div className="partstype-header">
                    <Backbtn />
                    <div className="title">
                        <p>เลือกประเภท</p>
                        <p className="air-brand">{this.state.title}</p>
                    </div>
                    <Nav />
                </div>
                <div className="partstype-type container">
                    {(this.state.type_wall !== "0")? <div className="each-type">
                        <Link to={{ pathname:"/productdetail", search:`?title=${this.state.title}&type=wall&type_wall=${this.state.type_wall}&type_hang=${this.state.type_hang}&type_four=${this.state.type_four}&type_concealed=${this.state.type_concealed}&type_stand=${this.state.type_stand}`}}>
                            <img src={require("../static/images/03_product_02/01.jpg")} alt="แอร์ผนัง"/>
                            <h3>แอร์ผนัง</h3>
                        </Link>
                    </div>:""}
                    {(this.state.type_hang !== "0")? <div className="each-type">
                        <Link to={{ pathname:"/productdetail", search:`?title=${this.state.title}&type=hang&type_wall=${this.state.type_wall}&type_hang=${this.state.type_hang}&type_four=${this.state.type_four}&type_concealed=${this.state.type_concealed}&type_stand=${this.state.type_stand}`}}>
                            <img src={require("../static/images/03_product_02/02.jpg")} alt="แอร์แขวน"/>
                            <h3>แอร์แขวน</h3>
                        </Link>
                    </div>:""}
                    {(this.state.type_four !== "0")? <div className="each-type">
                        <Link to={{ pathname:"/productdetail", search:`?title=${this.state.title}&type=four&type_wall=${this.state.type_wall}&type_hang=${this.state.type_hang}&type_four=${this.state.type_four}&type_concealed=${this.state.type_concealed}&type_stand=${this.state.type_stand}`}}>
                            <img src={require("../static/images/03_product_02/03.jpg")} alt="แอร์สี่ทิศทาง"/>
                            <h3>แอร์สี่ทิศทาง</h3>
                        </Link>
                    </div>:""}
                    {(this.state.type_four !== "0")? <div className="each-type">
                        <Link to={{ pathname:"/productdetail", search:`?title=${this.state.title}&type=four&type_wall=${this.state.type_wall}&type_hang=${this.state.type_hang}&type_four=${this.state.type_four}&type_concealed=${this.state.type_concealed}&type_stand=${this.state.type_stand}`}}>
                            <img src={require("../static/images/03_product_02/oneway.jpg")} alt="แอร์หนึ่งทิศทาง"/>
                            <h3>แอร์หนึ่งทิศทาง</h3>
                        </Link>
                    </div>:""}
                    {(this.state.type_concealed !== "0")? <div className="each-type">
                        <Link to={{ pathname:"/productdetail", search:`?title=${this.state.title}&type=concealed&type_wall=${this.state.type_wall}&type_hang=${this.state.type_hang}&type_four=${this.state.type_four}&type_concealed=${this.state.type_concealed}&type_stand=${this.state.type_stand}`}}>
                            <img src={require("../static/images/03_product_02/04.jpg")} alt="แอร์เปลือย"/>
                            <h3>แอร์เปลือย</h3>
                        </Link>
                    </div>:""}
                    {(this.state.type_stand !== "0")? <div className="each-type">
                        <Link to={{ pathname:"/productdetail", search:`?title=${this.state.title}&type=stand&type_wall=${this.state.type_wall}&type_hang=${this.state.type_hang}&type_four=${this.state.type_four}&type_concealed=${this.state.type_concealed}&type_stand=${this.state.type_stand}`}}>
                            <img src={require("../static/images/03_product_02/05.jpg")} alt="แอร์ตู้ตั้ง"/>
                            <h3>แอร์ตู้ตั้ง</h3>
                        </Link>
                    </div>:""}
                </div>
                <Footer />
            </div>
        )
    }
}
 
export default Partstype;